<template>
  <div>
    <div class="p-2" :style="skin.my_account.menu_item_border">
      <h5 :style="skin.my_account.header_nav_text2">{{ translate("request_withdrawal") }}</h5>
    </div>
    <div v-if="response.result == 'Ok'" class="alert alert-success fade show" role="alert">
      {{ response.msg }}
    </div>
    <div v-if="response.result == 'error'" class="alert alert-danger fade show" role="alert">
      {{ response.msg }}
    </div>
    <div v-if="skin.my_account.request_payment_target.normal" class="row p-2">
      <form @submit.prevent="confirmRequest()" class="col-12 col-lg-6">
        <span :style="skin.my_account.header_nav_text2">{{ translate("balance_availble") }}</span>&nbsp;
        <span v-if="user.user_data?.data?.bonus_balance != null" :style="skin.my_account.header_nav_text2">{{ new
          Intl.NumberFormat("de-DE").format(user.user_data.data.bonus_balance) + ' ' + user.user_data.data.currency}}</span>
        <span v-if="user.user_data?.data?.balance_available != null" :style="skin.my_account.header_nav_text2">{{ new
          Intl.NumberFormat("de-DE").format(user.user_data.data.balance_available) + ' '+user.user_data.data.currency}}</span>
        <div class="py-2">
          <label for="amount" :style="skin.my_account.header_nav_text2">{{ translate("amount_withdraw") }}</label>
          <input v-model="amount" type="number" step="any" class="form-control" placeholder="0" id="amount" required>
          <div v-if="skin.my_account.request_payment_target.enabled">
            <label for="type">{{ translate("payment_type") }}</label>
            <select class="form-control" name="type" v-model="payment_type" id="type" required>
              <option v-for="(payment_type, idx) in skin.my_account.request_payment_target.types" :key="idx"
                :value="payment_type">{{ translate(payment_type) }}</option>
            </select>
            <div v-if="payment_type == 'PIX'">
              <label for="account_type">{{ translate("account_type") }}</label>
              <select class="form-control" name="type" v-model="account_type" id="account_type" required>
                <option value="email">Email</option>
                <option value="phone">{{ translate("phone") }}</option>
                <option value="cpf">CPF</option>
                <option value="cnpj">CNPJ</option>
                <option value="random_key">{{ translate("random_key") }}</option>
              </select>
              <label for="payment_description">{{ translate("payment_description_pix") }} {{ account_type != "" ? "-"+translate(account_type).toUpperCase():"" }}</label>
              <input v-model="payment_description" type="text" class="form-control"
                :placeholder="account_type != '' ? translate(account_type).toUpperCase() : ''" id="payment_description"
                required>
              <label for="account_owner_name">{{ translate("account_owner_name") }}</label>
              <input v-model="account_owner_name" type="text" class="form-control"
                :placeholder="translate('account_owner_name')" id="account_owner_name" required>
              <label for="account_owner_dni">{{ translate("account_owner_cpf") }}</label>
              <input v-model="account_owner_dni" type="text" class="form-control"
                :placeholder="translate('account_owner_cpf')" id="account_owner_dni" required>
            </div>
            <div v-else-if="payment_type == 'bank_transfer'">
              <div v-if="skin.my_account.request_payment_target[payment_type]">
                <label>{{ translate('bank') }}</label>
                <select class="form-control" name="type" v-model="bank" id="bank_name" required>
                  <option v-for="(option, index) in skin.my_account.request_payment_target[payment_type].banks"
                    :key="index" :value="option">{{ option }}</option>
                </select>
                <label>{{ translate('account_type') }}</label>
                <select class="form-control" name="type" v-model="account_type" id="bank_name" required>
                  <option v-for="(option, index) in skin.my_account.request_payment_target[payment_type].account_types"
                    :key="index" :value="option">{{ option }}</option>
                </select>
              </div>
              <label for="description">{{ translate("payment_description") }}</label>
              <input v-model="payment_description" type="text" class="form-control"
                :placeholder="translate('bank_account_data')" id="payment_description" required>
              <label for="account_owner_name">{{ translate("account_owner_name") }}</label>
              <input v-model="account_owner_name" type="text" class="form-control"
                :placeholder="translate('account_owner_name')" id="account_owner_name" required>
              <label for="account_owner_dni">{{ translate("account_owner_dni") }}</label>
              <input v-model="account_owner_dni" type="text" class="form-control"
                :placeholder="translate('account_owner_dni')" id="account_owner_dni" required>
            </div>
          </div>
        </div>
        <div class="py-4">
          <button type="submit" :style="skin.qbet.booking_btn" class="p-2 text-center mb-2"
            style="width:100%;color:white" :disabled="request_inProcess">{{ translate("confirm") }}</button>
        </div>
      </form>
    </div>
    <div v-if="skin.auto_payment?.providers[2]?.enabled"
      class="pb-2 font-size-custom mb-2 my-1 d-flex justify-content-center w-100">
      <select v-model="selectedMethod" class="form-control input-login mr-sm-2 my-sm-0">
        <option disabled value="">{{ translate('choose_method') }}</option>
        <option v-for="method in methods" :key="method" :value="method">
          {{ method }}
        </option>
      </select>
    </div>
    <div v-if="selectedMethod == 'PIX'">
      <form @submit.prevent="withdraw_pix" class="p-1 my-3">
        <!-- Selección de moneda -->
        <h4 :style="skin.my_account.menu_item_border" style="font-size: 12px;">PIX KEY TYPE</h4>
        <div class="pb-2 font-size-custom mb-2 my-1 d-flex justify-content-center w-100">
          <select v-model="pix_key_type" class="form-control input-login mr-sm-2 my-sm-0">
            <option disabled value="">{{ translate('Choose Pix Key') }}</option>
            <option v-for="pix_key_ty in pix_key_types" :key="pix_key_ty" :value="pix_key_ty">
              {{ pix_key_ty }}
            </option>
          </select>
        </div>
        <div v-if="pix_key_type != ''" class="pb-2 font-size-custom mb-2 my-1 d-flex justify-content-center w-100">
          <input v-model="pix_key" id="amountW" type="text" :placeholder="translate('Pix Key')"
            class="form-control input-login mr-sm-2  my-sm-0" autocomplete="off">
        </div>
        <div class="pb-2 font-size-custom mb-2 my-1 d-flex justify-content-center w-100">
          <input v-model="tax_id" id="amountW" type="text" :placeholder="translate('Identfication Number')"
            class="form-control input-login mr-sm-2  my-sm-0" autocomplete="off">
        </div>
        <h4 :style="skin.my_account.menu_item_border" style=" font-size: 12px;">AMOUNT IN BRL</h4>
        <div class="pb-2 font-size-custom mb-2 my-1 d-flex justify-content-center w-100">
          <input v-model="amount" id="destinationTagW" type="number" step="0.01" min="0.01"
            :placeholder="translate('Amount')" class="form-control input-login mr-sm-2  my-sm-0" autocomplete="off"
            required>
        </div>
        <div class="d-flex mb-1 align-content-center justify-content-center">
          <button id="submit_btnpw" type="submit" class="btn p-2 login-btn"
            :style="{ 'background-color': skin.main_modal_background, 'color': skin.main_modal_text }"
            style="color:black;width: 50%;" :disabled="!pix_key || !pix_key_type">
            <span v-if="loading">
              <i class="fas fa-spinner fa-spin"></i> <!-- Spinner -->
            </span>
            <span v-else>
              {{ translate('Confirm Withdraw') }}
            </span>
          </button>
        </div>
      </form>
    </div>
    <div v-if="withdrawDataForm?.error || status.message != ''" :class="'alert alert-' + status.type" class="p-0"
      role="alert" style="color:brown; font-size: 15px;">{{ withdrawDataForm.error || status.message }}
    </div>
  </div>
</template>

<script>
import axios from 'axios';
export default {
  name: "request_payment",
  props: ["skin", "language", "translation"],
  data() {
    return {
      status: {
        message: "",
        type: ""
      },
      request_inProcess: false,
      amount: 0,
      payment_type: "",
      payment_description: "",
      response: { result: "", msg: "" },
      bank: "",
      account_type: "",
      account_owner_name: "",
      account_owner_dni: "",
      loading: false,
      cardName: 'Alejandra Castañeda',
      cardEmail: 'marialejac120@gmail.com',
      selectedBank: '',
      usuTelefono: "",
      usuTipdoc: "CC",
      numCuenta: "3157210552",
      tipoCuenta: "AHORRO",
      cuentaType: ["AHORRO", "CORRIENTE"],
      docs: ['CC', 'NIT'],
      pix_key_types: ['CPF', 'CNPJ', 'PHONE', 'EMAIL', 'EVP'],
      "tax_id": "",
      "pix_key_type": "",
      "pix_key": "",
      transactionFeesUrl: 'https://docs.0xprocessing.com/basic/general/transaction-fees', // URL para ver las Transaction Fees
      amount: 1.0,
      address: '',
      selectedMethod: '', // Moneda seleccionada
      login_inProcess: false,
      methods: ['PIX'],

    }
  },
  methods: {
    async confirmRequest() {
      this.request_inProcess = true
      let plataforma = this.$store.getters['getConfig'].main.site_name;
      let data = {
        "command": "retirar", "params": {
          "valor": this.amount,
          "usuario": "",
          "plataforma": plataforma,
          "wallet": "",
          "tipo": this.payment_type,
          "celular": "",
          "email": this.user.user_data.data.email,
          "extra_data": {
            "account_owner_name": this.account_owner_name,
            "account_owner_dni": this.account_owner_dni,
            "account_type": this.account_type,
            "account_value": this.payment_description,
            "account_entity": this.bank
          }
        }
      }
      const response = await axios.post(this.user.domain + '/' + this.user.prefix + '/scommand?access_token=' + this.user.token + '&site=' + this.user.site, data);
      if (response.data.result == 'Ok') {
        this.response.result = "Ok";
        this.response.msg = response.data.msg;
        this.amount = "";
        this.payment_type = "";
        this.account_owner_name = "";
        this.account_owner_dni = "";
        this.account_type = "";
      }
      else if (response.data.result == 'error') {
        this.response.result = "error";
        this.response.msg = response.data.msg;
        if (response.data.needValidation) {
          this.$root.$emit('send_phone_code');
        }
      }
      this.request_inProcess = false;
    },
    async withdraw_pix() {
      this.status.message = "";
      this.status.type = "";

      // Validar campos obligatorios
      if (!this.pix_key_type || !this.pix_key || !this.tax_id) {
        this.status.message = this.translate("All fields are required");
        this.status.type = "danger";
        return;
      }

      // Expresiones regulares para validar formatos
      const regexCPF = /^(?:\d{3}\.\d{3}\.\d{3}-\d{2}|\d{11})$/;
      const regexCNPJ = /^(?:\d{2}\.\d{3}\.\d{3}\/0001-\d{2}|\d{14})$/;
      const regexPhone = /^(?:\+55\d{11,12}|\d{10,11})$/;
      const regexEmail = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
      const regexEVP = /^[a-fA-F0-9-]{36}$/;

      // // Validar tax_id según el país
      // if (!regexCPF.test(this.tax_id) && !regexCNPJ.test(this.tax_id)) {
      //     this.status.message = this.translate("Invalid tax ID format");
      //     this.status.type = "danger";
      //     return;
      // }

      // // Validar pix_key según el tipo seleccionado
      // switch (this.pix_key_type) {
      //     case "CPF":
      //         if (!regexCPF.test(this.pix_key)) {
      //             this.status.message = this.translate("Invalid CPF format");
      //             this.status.type = "danger";
      //             return;
      //         }
      //         break;
      //     case "CNPJ":
      //         if (!regexCNPJ.test(this.pix_key)) {
      //             this.status.message = this.translate("Invalid CNPJ format");
      //             this.status.type = "danger";
      //             return;
      //         }
      //         break;
      //     case "PHONE":
      //         if (!regexPhone.test(this.pix_key)) {
      //             this.status.message = this.translate("Invalid phone format");
      //             this.status.type = "danger";
      //             return;
      //         }
      //         break;
      //     case "EMAIL":
      //         if (!regexEmail.test(this.pix_key)) {
      //             this.status.message = this.translate("Invalid email format");
      //             this.status.type = "danger";
      //             return;
      //         }
      //         break;
      //     case "EVP":
      //         if (!regexEVP.test(this.pix_key)) {
      //             this.status.message = this.translate("Invalid EVP format");
      //             this.status.type = "danger";
      //             return;
      //         }
      //         break;
      //     default:
      //         this.status.message = this.translate("Invalid PIX key type");
      //         this.status.type = "danger";
      //         // this.$store.commit("getPayment",{error:"Invalid PIX key type"})
      //         return;
      // }

      this.loading = true;
      this.status.message = this.translate("");

      // Enviar datos al store Vuex
      this.$store.dispatch("setAmountPix", {
        data: {
          tax_id_country: "BRA",
          tax_id: this.tax_id,
          pix_key_type: this.pix_key_type,
          pix_key: this.pix_key
        },
        amount: parseFloat(this.amount)
      });

      setTimeout(async () => {
        await this.$store.dispatch("getPixWithdraw");
      }, 200);

      setTimeout(async () => {
        this.loading = false;
        if (!this.withdrawDataForm.error) {
          this.status.message = this.translate("Withdrawal request sent successfully");
          this.status.type = "success";
        }
        setTimeout(async () => {
          document.getElementById("closeLoginW").click();
        }, 1000);
      }, 2000);
    },
    translate(text) {
      if (text) {
        if (this.$props.translation[text]) {
          return this.$props.translation[text][this.$props.language];
        }
        else {
          var new_text_serched = text.replace(/ /g, "_");
          if (this.$props.translation[new_text_serched]) {
            return this.$props.translation[new_text_serched][this.$props.language];
          }
        }
        return text;
      }
    },
  },
  computed: {
    user() {
      return this.$store.getters['getUserData'];
    },
    withdrawData() {
      // console.log(this.$store.getters["getWithdrawData"])
      let data = this.$store.getters["getWithdrawData"].withdrawalData != undefined ? this.$store.getters["getWithdrawData"].withdrawalData != undefined : this.$store.getters["getWithdrawData"]
      // console.log(data)
      return data
    },
    withdrawDataForm() {
      // console.log(this.$store.getters["getWithdraw"])
      let data = this.$store.getters["getWithdraw"].withdrawalData != undefined ? this.$store.getters["getWithdraw"].withdrawalData != undefined : this.$store.getters["getWithdraw"]
      // console.log(data)
      return data
      // return this.$store.getters["getWithdraw"]

    },
  },
  watch: {
    account_type(newVal) {
      if (newVal == "email") {
        this.payment_description = this.user.user_data.data.email;
        this.account_owner_name = this.user.user_data.data.name
        this.account_owner_dni = this.user.user_data.data.doc_number;
        document.getElementById("payment_description").readOnly = true;
        document.getElementById("account_owner_name").readOnly = true;
        document.getElementById("account_owner_dni").readOnly = true;
      }
      else if (newVal == "phone") {
        this.payment_description = this.user.user_data.data.phone;
        this.account_owner_name = this.user.user_data.data.name
        this.account_owner_dni = this.user.user_data.data.doc_number;
        document.getElementById("payment_description").readOnly = true;
        document.getElementById("account_owner_name").readOnly = true;
        document.getElementById("account_owner_dni").readOnly = true;
      }
      else if (newVal == "cpf") {
        this.payment_description = this.user.user_data.data.doc_number;
        this.account_owner_name = this.user.user_data.data.name
        this.account_owner_dni = this.user.user_data.data.doc_number;
        document.getElementById("payment_description").readOnly = true;
        document.getElementById("account_owner_name").readOnly = true;
        document.getElementById("account_owner_dni").readOnly = true;
      }
      else {
        document.getElementById("payment_description").readOnly = false;
        document.getElementById("account_owner_name").readOnly = true;
        document.getElementById("account_owner_dni").readOnly = true;
        this.account_owner_name = this.user.user_data.data.name
        this.account_owner_dni = this.user.user_data.data.doc_number;
        this.payment_description = "";
      }
    }
  },
  mounted() {
    if (this.$store.getters["getSite"] == 86174) {
      this.$store.dispatch('setWithdraw')
    }
  }
}
</script>

<style></style>